import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-skip-forward-sharp",
  "use": "icon-play-skip-forward-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-play-skip-forward-sharp\"><title>Play Skip Forward</title><path d=\"M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol